module.exports = __webpack_public_path__ + "img/language.0be23e21.png";